import { bool, func, number, node, oneOfType, string } from 'prop-types';
import React, { useState } from 'react';
import { OverlayTrigger, Tooltip } from '@ajaibid/components';

import { noop } from '@ajaibid/utils';
import { Icon } from '../Icon';

import styles from './style';

const ButtonIcon = (props) => {
  const {
    onClick,
    src,
    size,
    color,
    noImage,
    backgroundHover,
    width,
    height,
    showTooltip,
    textTooltop,
    tooltipPosition,
    ...otherProps
  } = props;

  const [hover, setHover] = useState(false);

  const buttonStyles = { ...styles.buttonIcon };
  const buttonStylesHover = { ...styles.buttonIconHover };
  if (backgroundHover) {
    buttonStylesHover.background = backgroundHover;
  }
  if (width) {
    buttonStyles.width = width;
    buttonStylesHover.width = width;
  }
  if (height) {
    buttonStyles.height = height;
    buttonStylesHover.height = height;
  }

  const toolTip = () => (
    <div
      onClick={onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={hover ? buttonStylesHover : buttonStyles}
      role="button"
      {...otherProps}
    >
      {noImage ? src : <Icon src={src} size={size} color={color} />}
    </div>
  );

  return showTooltip ? (
    <OverlayTrigger
      placement={tooltipPosition || 'bottom'}
      overlay={<Tooltip id="tooltip-top">{textTooltop}</Tooltip>}
    >
      {toolTip()}
    </OverlayTrigger>
  ) : (
    toolTip()
  );
};

ButtonIcon.propTypes = {
  backgroundHover: string,
  color: string,
  height: oneOfType([string, number]),
  noImage: bool,
  onClick: func,
  showTooltip: bool,
  size: oneOfType([string, number]),
  src: oneOfType([string, node]),
  textTooltop: string,
  tooltipPosition: string,
  width: oneOfType([string, number])
};

ButtonIcon.defaultProps = {
  backgroundHover: '',
  color: '',
  height: 0,
  noImage: false,
  onClick: noop,
  showTooltip: false,
  size: 0,
  src: '',
  textTooltop: '',
  tooltipPosition: '',
  width: 0
};

export default ButtonIcon;
